// components/AdminList/ActionsMenu.jsx
import React, { useEffect, useRef, useState } from "react";

export default function ActionsMenu({ items = [] }) {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        const onDoc = (e) => { if (open && ref.current && !ref.current.contains(e.target)) setOpen(false); };
        const onKey = (e) => { if (e.key === "Escape") setOpen(false); };
        document.addEventListener("mousedown", onDoc);
        document.addEventListener("keydown", onKey);
        return () => { document.removeEventListener("mousedown", onDoc); document.removeEventListener("keydown", onKey); };
    }, [open]);

    return (
        <div className="actions-menu" ref={ref}>
            <button className="btn btn--ghost actions-menu__btn" onClick={() => setOpen((v) => !v)} aria-expanded={open}>
                <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
                    <circle cx="5" cy="12" r="2" />
                    <circle cx="12" cy="12" r="2" />
                    <circle cx="19" cy="12" r="2" />
                </svg>
                <span className="hide-sm">Действия</span>
            </button>

            {open && (
                <div className="actions-menu__panel" onClick={(e) => e.stopPropagation()}>
                    {items.map((it, i) =>
                        it.type === "sep" ? (
                            <div key={`sep-${i}`} className="am-sep" />
                        ) : it.href ? (
                            <a key={i} className={`am-item ${it.variant || ""}`} href={it.href} target={it.target || "_blank"} rel="noopener noreferrer" onClick={() => setOpen(false)}>
                                {it.label}
                            </a>
                        ) : (
                            <button key={i} className={`am-item ${it.variant || ""}`} disabled={it.disabled} onClick={async () => { await it.onClick?.(); setOpen(false); }}>
                                {it.label}
                            </button>
                        )
                    )}
                </div>
            )}
        </div>
    );
}
